import { AuthorizationSSOConfiguration, LoginOptions, LoginSettingsAPIResponse, LoginTypeOptions } from 'frontcore/domain/authorization/model/types'
import { computed, readonly, ref, Ref } from 'vue'
import { defineStore } from 'pinia'

const useLoginConfigurationStore = defineStore('loginConfiguration', () => {
  const loginType: Ref<LoginTypeOptions> = ref(LoginTypeOptions.Django)
  const loginOptions: Ref<LoginOptions | undefined> = ref()
  const ssoConfiguration: Ref<AuthorizationSSOConfiguration | null> = ref(null)

  const isSSOLogin = computed(() => loginType.value === LoginTypeOptions.SSO)
  const isSAMLLogin = computed(() => loginType.value === LoginTypeOptions.SAML)
  
  const setLoginConfiguration = (loginSettings: LoginSettingsAPIResponse) => {
    loginType.value = loginSettings.TYPE
    loginOptions.value = {
      clientId: loginSettings.OPTIONS?.CLIENT_ID ?? '',
      logoutUrl: loginSettings.OPTIONS?.LOGOUT_ENDPOINT ?? '',
    }
  }

  const createOpenIDConfiguration = (
    apiURL: string,
    publicPath?: string
  ) => {
    if (!loginOptions.value) {
      return
    }
    ssoConfiguration.value = {
      authorizationEndpoint: `${apiURL}/oauth/`,
      clientId: loginOptions.value.clientId ?? '',
      endSessionEndpoint: loginOptions.value.logoutUrl ?? '',
      isActive: isSSOLogin.value,
      redirectUri: `${window.location.origin}${publicPath ?? '/'}`,
      tokenEndpoint: `${apiURL}/token/`,
    }
    return ssoConfiguration.value
  }

  return {
    isSAMLLogin,
    isSSOLogin,
    loginTypeValue: readonly(loginType),
    loginOptionsValue: readonly(loginOptions),
    ssoConfigurationValue: readonly(ssoConfiguration),
    createOpenIDConfiguration,
    setLoginConfiguration,
  }
})

export default useLoginConfigurationStore
